import axios from 'axios'
import { createSelector } from 'reselect'
import {
  AgendamentoModel,
  CfcModel,
  CotistaModel,
  Modalidade,
  RepasseModel,
  StatusAgendamento,
  TipoCurso,
  TurmaModel,
  StatusTimeLine,
  TurmasInfoModel,
} from '../../../components/models/Models'
import { notification } from 'antd'
import { createSimpleStore } from 'react-simple-reducer'
import { webservicesBaseURL } from '../../../App'

export type ParamsPilotarDto = {
  cnpjCfcPilotar: string
  cpfPilotar: string
  telefonePilotar: string
  renach: string
  tipoProcesso: string
}
const initialState = {
  status: 'HIDDEN' as StatusAgendamento,
  timeLine: 'HIDDEN' as StatusTimeLine,
  agendamento: {
    tipoAgendamento: 'REGULAR',
    tipoCurso: 'PRIMEIRA_VIA',
    cpf: '',
    nome: '',
    telefone: '',
    email: '',
    renach: '',
    dataRenach: '',
    isCnhSocial: false,
    isAgendamentoVsoft: false,
    identificadorCobranca: '',
    readOnly: false,
  } as AgendamentoModel,
  hasRepasses: false,
  municipio: '' as string,
  cfcsOrigem: [] as CfcModel[],
  cotistas: [] as CotistaModel[],
  cfcsDestino: [] as CfcModel[],
  tipoCursoOpcoes: [
    { nome: 'PRIMEIRA VIA', valor: 'PRIMEIRA_VIA' },
    { nome: 'RENOVAÇÃO', valor: 'RENOVACAO' },
  ],
  modalidade: 'MATUTINO' as Modalidade,
  turmas: [] as TurmaModel[],
  cfcRodizioGoiania: null as CfcModel | null,
  turmasInfo: null as TurmasInfoModel | null,
  loadingTurmas: false,
  loadingDadosAluno: false,
  loadingDadosAlunoPilotar: false,
  isTelefoneValid: false,
  paramsPilotar: null as ParamsPilotarDto | null,
  loadingCfcsOrigem: false,
  statusParamsPilotar: 'NO_PARAMS' as 'HAS_PARAMS' | 'NO_PARAMS' | 'INVALID_PARAMS',
  loadingCreateAgendamento: false,
}

export const AgendarStore = createSimpleStore(
  {
    ...initialState,
  },
  {
    handleCobrancaSuccess(state, agendamento) {
      state.status = agendamento.status
    },
    searchAgendamentoSuccess(
      state,
      { agendamento, paramsPilotar }: { agendamento: any; paramsPilotar?: ParamsPilotarDto }
    ) {
      const {
        isCnhSocial,
        cpf,
        renach,
        dataRenach,
        nome,
        telefone,
        cnhSocial,
        tipoAgendamento,
        ...rest
      } = agendamento
      state.loadingDadosAluno = false
      state.loadingDadosAlunoPilotar = false
      if (!rest || Object.keys(rest).length === 0) {
        state.timeLine = 'DADOS_ALUNOS'
        state.status = 'NOVO'
        state.agendamento.tipoAgendamento = tipoAgendamento
        state.agendamento.isCnhSocial = isCnhSocial
        return
      }
      state.agendamento = { ...agendamento, tipoAgendamento, isCnhSocial }

      if (paramsPilotar) {
        const tipoCurso =
          paramsPilotar.tipoProcesso === 'PRIMEIRA_HABILITACAO' ? 'PRIMEIRA_VIA' : 'RENOVACAO'
        state.paramsPilotar = paramsPilotar
        state.statusParamsPilotar = 'HAS_PARAMS'
        state.agendamento.telefone = paramsPilotar.telefonePilotar
        state.isTelefoneValid = true
        state.agendamento.tipoCurso = tipoCurso
      }

      if (isCnhSocial && agendamento.status === 'PENDENTE') {
        state.status = 'PAGO'
        state.timeLine = 'AGENDAMENTO'
        return
      }

      if (agendamento.status === 'AGENDADO') state.timeLine = 'FIM'
      if (agendamento.status === 'PENDENTE') state.timeLine = 'AGENDAMENTO'

      state.status = agendamento.status
    },
    searchAgendamentoError(state) {
      state.loadingDadosAluno = false
    },
    searchAgendamentoStarted(state) {
      state.loadingDadosAluno = true
    },
    getAlunoDatasSuccess(state, aluno) {
      state.agendamento.nome = aluno.nome
      state.agendamento.renach = aluno.renach
    },
    createAgendamentoSuccess(state, agendamento) {
      state.agendamento = agendamento
      state.loadingCreateAgendamento = false

      if (agendamento.isCnhSocial && agendamento.status === 'PENDENTE') {
        state.status = 'PAGO'
        state.timeLine = 'AGENDAMENTO'
        return
      }
      state.timeLine = 'TURMAS'
      state.status = agendamento.status
    },
    changeTipoCurso(state, tipoCurso: TipoCurso) {
      state.agendamento.tipoCurso = tipoCurso
    },
    changeOptionRepasse(state, optionRepasse: boolean) {
      state.hasRepasses = optionRepasse
    },
    changeCpf(state, cpf: string) {
      state.agendamento.cpf = cpf
    },
    changeNome(state, nome: string) {
      state.agendamento.nome = nome
    },
    changeRenach(state, renach: string) {
      state.agendamento.renach = renach
    },
    changeTelefone(state, telefone: string) {
      state.agendamento.telefone = telefone
    },
    getCfcsOrigemSuccess(state, cfcsOrigem: CfcModel[]) {
      state.loadingCfcsOrigem = false
      state.cfcsOrigem = cfcsOrigem
    },
    getCfcsOrigemStarted(state) {
      state.loadingCfcsOrigem = true
    },
    getCfcsOrigemError(state) {
      state.loadingCfcsOrigem = false
    },
    getCfcsDestinoSuccess(state, payload: { cfcsDestino: CfcModel[] }) {
      state.cfcsDestino = payload.cfcsDestino
      // state.cfcRodizioGoiania = payload.cfcRodizioGoiania
    },
    changeMunicipio(state, municipio: string) {
      state.municipio = municipio
      state.agendamento.cfcDestino = null
    },
    changeCfcOrigem(state, cfcOrigem: CfcModel | null) {
      state.municipio = ''
      state.agendamento.cfcOrigem = cfcOrigem
      if (cfcOrigem) state.municipio = cfcOrigem.municipio
      state.cotistas = []
    },
    changeCotista(state, cotista: CotistaModel | null) {
      state.agendamento.cotista = cotista
    },
    changeCfcDestino(state, cfcDestino: CfcModel | null) {
      state.agendamento.cfcDestino = cfcDestino
      // const tipoCursoOpcoes = JSON.parse(cfcDestino?.tipoCursoOpcoes || '[]')
      // state.tipoCursoOpcoes = tipoCursoOpcoes
      state.timeLine = cfcDestino ? 'TIPO_CURSO' : 'DADOS_ALUNOS'
    },
    changeModalidade(state, modalidade) {
      state.modalidade = modalidade
    },
    getTurmasSuccess(state, turmas) {
      state.turmas = turmas
      state.loadingTurmas = false
    },
    getTurmasStarted(state) {
      state.loadingTurmas = true
    },
    getTurmasFailed(state) {
      state.turmasInfo = null
      state.loadingTurmas = false
    },
    getTurmasInfoSuccess(state, turmasInfo) {
      state.turmasInfo = turmasInfo
      state.loadingTurmas = false
    },
    getTurmaSuccess(state, turma) {
      state.agendamento!.turma = turma
    },
    agendarSuccess(state, turmaId) {
      if (!state.agendamento) return
      // state.status = 'AGENDADO'
      state.agendamento.turmaId = turmaId
    },
    searchCotistasSuccess(state, cotistas) {
      state.cotistas = cotistas
    },
    clearAgendamento(state) {
      state.status = 'HIDDEN'
      state.municipio = ''
      state.timeLine = 'HIDDEN'
      state.hasRepasses = false
      state.agendamento = {
        tipoAgendamento: 'REGULAR',
        tipoCurso: 'PRIMEIRA_VIA',
        cpf: state.agendamento.cpf,
        nome: '',
        telefone: '',
        email: '',
        renach: '',
        dataRenach: '',
        cfcOrigem: null,
        cotista: null,
        cfcDestino: null,
        isCnhSocial: false,
        isAgendamentoVsoft: false,
      }
    },
    changeTimeLineStatusDadosAluno(state) {
      state.timeLine = 'DADOS_ALUNOS'
    },
    clear(state) {
      state = { ...initialState }
    },
    changeIsTelefoneValid(state, isTelefoneValid: boolean) {
      state.isTelefoneValid = isTelefoneValid
    },
    setSearchParams(state, { params, status }: { params: ParamsPilotarDto | null; status: any }) {
      state.paramsPilotar = params
      state.statusParamsPilotar = status
    },
    searchAgendamentoPilotarStarted(state) {
      state.loadingDadosAlunoPilotar = true
    },
    searchAgendamentoPilotarSuccess(state) {
      state.loadingDadosAlunoPilotar = false
    },
    searchAgendamentoPilotarError(state) {
      state.loadingDadosAlunoPilotar = false
    },
    createAgendamentoStarted(state) {
      state.loadingCreateAgendamento = true
    },
    createAgendamentoError(state) {
      state.loadingCreateAgendamento = false
    },
  },
  {
    thunks: {
      changeCfcAndSearchCotistas(cfcOrigem) {
        return async (dispatch) => {
          dispatch(AgendarStore.actions.changeCfcOrigem(cfcOrigem || null))

          let formatedCnpjCfcOrigem = cfcOrigem.cnpj.replace(/[^\d]+/g, '')

          try {
            const cotistas = await axios
              .get(`cfcs/cfcs-origem/cotistas/${formatedCnpjCfcOrigem}`)
              .then((x) => x.data)
            dispatch(AgendarStore.actions.searchCotistasSuccess(cotistas))
          } catch (error: any) {
            notification.error({ message: error.response?.data?.message })
          }
        }
      },
      handleCobranca(cpf) {
        return async (dispatch) => {
          try {
            const agendamento = await axios.get(`/agendamentos/cpf/${cpf}`).then((x) => x.data)
            dispatch(AgendarStore.actions.handleCobrancaSuccess(agendamento))
          } catch (error: any) {
            notification.error({
              message:
                error.response?.data?.message ||
                'Ocorreu um erro na busca por registros, serviço temporariamente indisponível',
            })
          }
        }
      },
      searchAgendamento(cpf) {
        return async (dispatch) => {
          try {
            dispatch(AgendarStore.actions.searchAgendamentoStarted())
            const agendamento = await axios.get(`/agendamentos/cpf/${cpf}`).then((x) => x.data)
            dispatch(AgendarStore.actions.searchAgendamentoSuccess({ agendamento }))
          } catch (error: any) {
            dispatch(AgendarStore.actions.searchAgendamentoError())
            notification.error({
              message:
                error.response?.data?.message ||
                'Ocorreu um erro na busca por registros, serviço temporariamente indisponível',
            })
          }
        }
      },
      searchAgendamentoPilotar(paramsPilotar: ParamsPilotarDto) {
        return async (dispatch) => {
          try {
            dispatch(AgendarStore.actions.searchAgendamentoPilotarStarted())
            const agendamento = await axios
              .get(`/agendamentos/cpf/${paramsPilotar.cpfPilotar}/${paramsPilotar.renach}`)
              .then((x) => x.data)
            dispatch(AgendarStore.actions.searchAgendamentoSuccess({ agendamento, paramsPilotar }))
          } catch (error: any) {
            dispatch(AgendarStore.actions.searchAgendamentoPilotarError())
            notification.error({
              message:
                error.response?.data?.message ||
                'Ocorreu um erro na busca por registros, serviço temporariamente indisponível',
            })
          }
        }
      },
      createAgendamento(urlCallBack?: string | null) {
        return async (dispatch, getState) => {
          const {
            hasRepasses,
            agendamento: {
              tipoCurso,
              cpf,
              nome,
              renach,
              isCnhSocial,
              telefone,
              email,
              cfcOrigem,
              cfcDestino,
              isAgendamentoVsoft,
              dataRenach,
              cotista,
            },
          } = getState()

          try {
            dispatch(AgendarStore.actions.createAgendamentoStarted())
            const agendamento = await axios
              .post('/agendamentos/create-agendamento-regular', {
                tipoCurso,
                cpf,
                nome,
                renach,
                isCnhSocial,
                telefone,
                email,
                cfcOrigem,
                cotista,
                cfcDestino,
                isAgendamentoVsoft,
                dataRenach,
                hasRepasses,
                webhook: urlCallBack ?? '',
              })
              .then((x) => x.data)

            dispatch(
              AgendarStore.actions.createAgendamentoSuccess({
                status: 'PENDENTE',
                ...agendamento,
              })
            )
            notification.success({ message: 'Boleto criado com sucesso!' })
          } catch (error: any) {
            notification.error({
              message: error.response?.data?.message ?? 'Erro ao gerar boleto!',
            })
            dispatch(AgendarStore.actions.createAgendamentoError())
          }
        }
      },
      getCfcsOrigem() {
        return async (dispatch, getState) => {
          if (getState().cfcsOrigem.length !== 0) return
          try {
            dispatch(AgendarStore.actions.getCfcsOrigemStarted())
            const url = `${webservicesBaseURL}/contas/cfcs-origem/GO`
            const cfcsOrigem = await axios.get(url).then((x) => x.data)
            dispatch(AgendarStore.actions.getCfcsOrigemSuccess(cfcsOrigem))
          } catch (error: any) {
            dispatch(AgendarStore.actions.getCfcsOrigemError())
            const message =
              error?.response?.data?.message ??
              'Ocorreu um erro ao buscar os CFCs de origem, serviço temporariamente indisponível'
            notification.error({ message })
          }
        }
      },
      getCfcsDestino() {
        return async (dispatch) => {
          const cfcsDestino = await axios.get('/cfcs/cfcs-destino').then((x) => x.data)
          // const cfcRodizioGoiania = await axios.get('/cfcs/cfcs-destino/cfc-rodizio-goiania').then(rs => rs.data)
          dispatch(AgendarStore.actions.getCfcsDestinoSuccess({ cfcsDestino }))
        }
      },
      getTurmas(cfcDestinoId, tipoCurso) {
        return async (dispatch) => {
          try {
            if (tipoCurso) {
              const turmas = await axios
                .get(`/turmas/cfc-destino/${cfcDestinoId}/${tipoCurso}`)
                .then((x) => x?.data)
              dispatch(AgendarStore.actions.getTurmasSuccess(turmas))
            }
          } catch (error: any) {
            const message = error.response?.data?.message ?? 'Ocorreu um erro ao buscar as turmas!'
            notification.error({ message })
          }
        }
      },
      getTurmasByMunicipio(cfcsDestino, tipoCurso) {
        return async (dispatch) => {
          try {
            dispatch(AgendarStore.actions.getTurmasStarted())
            if (tipoCurso && cfcsDestino.length) {
              const cfcsDestinoIds = cfcsDestino.map((cfc: any) => cfc.id)
              const turmasInfo = await axios
                .post(`/turmas/cfcs-destino-municipio/${tipoCurso}`, { cfcsDestinoIds })
                .then((x) => x?.data)
              dispatch(AgendarStore.actions.getTurmasInfoSuccess(turmasInfo))
            }
            if (!cfcsDestino.length) {
              dispatch(AgendarStore.actions.getTurmasFailed())
            }
          } catch (error: any) {
            const message = error.response?.data?.message ?? 'Ocorreu um erro ao buscar as turmas!'
            dispatch(AgendarStore.actions.getTurmasFailed())
            notification.error({ message })
          }
        }
      },
    },
  }
)

export type IState = ReturnType<typeof AgendarStore.useState>

export const isCpfCompleto = createSelector(
  (s: IState) => s.agendamento.cpf,
  (cpf) => {
    return cpf?.replace(/[_.-]/g, '').length === 11
  }
)

export const selectMunicipios = createSelector(
  (s: IState) => s.cfcsDestino,
  (cfcsDestino) => {
    return Array.from(new Set(cfcsDestino.map((x: any) => x.municipio)))
  }
)

export const selectCfcsDestino = createSelector(
  (s: IState) => s.cfcsDestino,
  (s: IState) => s.municipio,
  (cfcsDestino, municipio) => {
    return [
      ...cfcsDestino.filter((x: any) => removeAcentos(x.municipio) === removeAcentos(municipio)),
    ].sort((a, b) => {
      return a.fantasia > b.fantasia ? 1 : -1
    })
  }
)

function removeAcentos(str: string) {
  return str?.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
}
